import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CurrencyConverter from "../../CurrencyConverter/CurrencyConverter";
import { FormattedMessage } from "react-intl";
import messages from "../../../locale/messages";
import s from "./ListingItem.css";

class ShowPrice extends Component {

    static propTypes = {
        totalPrice: PropTypes.bool,
        basePrice: PropTypes.number,
        oneTotalPrice: PropTypes.number,
        currency: PropTypes.string,
        isOneTotalToggle: PropTypes.bool,
    };

    render() {
        const { totalPrice, basePrice, oneTotalPrice, currency, isOneTotalToggle } = this.props;
        return (
            <>
                <CurrencyConverter
                    amount={isOneTotalToggle ? oneTotalPrice : basePrice}
                    from={currency}
                />
                {!isOneTotalToggle && (<span className={s.pernightText}> / <FormattedMessage {...messages.perNight} /></span>)}
                {isOneTotalToggle && (<span className={s.totalBeforeTaxText}> <FormattedMessage {...messages.totalBeforeTaxes} /> </span>)}
            </>
        )
    }
}

const mapState = (state) => ({
    isOneTotalToggle: state?.personalized?.isOneTotalToggle,
});

export default connect(mapState)(ShowPrice);